import * as Lockr from 'lockr';

import { ActionConstants } from '../constants/ActionConstants';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { AppFileApiHelper } from '../utils/AppFileApiHelper';
import { DebugState } from '../stores/DebugStore';
import { DownloadHelper } from '../utils/DownloadHelper';
import { FileFormats } from '../constants/FileFormat';
import { UrlArgumentsStore } from '../stores/UrlArgumentsStore';

import * as AppFileApiWrapper from '../submodules/app-api/Filesystem/Wrapper';
import { openFile as openFileWebAction } from '../submodules/app-api/DebugActions';
import { sendMessage, _fakeMessage } from '../submodules/app-api/Communication';
import { share } from '../submodules/app-api/Share';

import utils = egr.wcf.utils;

const DebugKnockNumber: number = 7;
const DebugKnockTimeout: number = 5000;

export class DebugActions {
    private static knockCounter: number = 0;

    public static updateSettings(state: DebugState): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.UPDATE_DEBUG_SETTINGS,
            value: state
        });
    }

    public static knock(): void {
        if (++DebugActions.knockCounter === DebugKnockNumber) {
            AppDispatcher.dispatch({
                actionType: ActionConstants.ENABLE_DEBUG_TAB
            });
        }
        setTimeout(
            () => {
                DebugActions.knockCounter--;
            },
            DebugKnockTimeout
        );
    }

    public static async syncContentUrl(): Promise<void> {
        const data: {id: number, url: string} = Lockr.get('pv:set_content_url');
        if (data != null && data.id != null && !utils.string.isNullOrEmpty(data.url)) {
            const response: ArrayBuffer = await DownloadHelper.getContent(data.url);
            if (response != null) {
                await sendMessage({
                    type: 'project',
                    action: 'update',
                    arguments: {
                        id: data.id,
                        content: utils.arraybuffer.toBase64(response)
                    }
                });
            }
        }
    }

    public static openFile(): void {
        openFileWebAction();
    }

    public static async exportFolder(path: string): Promise<void> {
        const zip: JSZip = new JSZip();
        await DebugActions.addFolderToZip(zip, path);

        if (AppConfigurationStore.getState().inApp && UrlArgumentsStore.getState()['debug-app'] == null) {
            const content: ArrayBuffer = await zip.generateAsync({type: 'arraybuffer'});
            await share({
                contentType: FileFormats.ZIP.mimetype,
                filename: 'fs_export.zip',
                uri: egr.wcf.utils.arraybuffer.toBase64(content),
            });
        } else {
            const content: Blob = await zip.generateAsync({type: 'blob'});
            DownloadHelper.downloadBlob(content, 'fs_export.zip');
        }
    }

    private static async addFolderToZip(zip: JSZip, path: string, zipPath: string = ''): Promise<void> {
        const entries: Array<string> = await AppFileApiWrapper.list(path);
        for (const entry of entries) {
            if (entry.endsWith('/')) {
                await DebugActions.addFolderToZip(zip, path + entry, zipPath + entry);
            } else {
                const data: ArrayBuffer = await AppFileApiHelper.readBinaryFile(path + entry);
                await zip.file(zipPath + entry, data, {binary: true});
            }
        }
    }
}
(window as {_DebugActions?: typeof DebugActions})._DebugActions = DebugActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/DebugActions.ts